/* eslint-disable react/prop-types */

import React, { useEffect, useState, useRef } from "react";
import ChatBody from "./ChatBody";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";
import ChatFooter from "./chatFooter";
import RadioButton from "../../Component/RadioButton";
const ChatRTMP = ({ chatPreference }) => {
  const [messages, setMessages] = useState([]);
  const lastMessageRef = useRef(null);
  const [showChatInput, setShowChatInput] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);
  const socketRef = useRef(null);
  const [socketInstance, setSocketInstance] = useState(null);
  const [roomUser, setRoomUser] = useState();
  const { streamKey, _id, name } = useSelector((state) => ({
    streamKey: state?.Auth?.streamKey,
    _id: state?.Auth?.userInfo?._id,
    name: state?.Auth?.userInfo?.name,
  }));
  useEffect(() => {
    const socket = io.connect(process.env.REACT_APP_BASEURL, {
      transports: ["websocket", "polling"], // Ensures WebSocket connection
      // autoConnect: false,
      secure: true,
      query: {
        room: streamKey,
        userId: _id,
        name: name,
      },
      withCredentials: true,
    });
    // Handle connection

    socket.on("connect", () => {
      console.log("Connected to WebSocket server:", "IFAS-CdcBAoiWnSr");
      socket.emit("get-room-users", streamKey);
    });

    socketRef.current = socket;
    setSocketInstance(socket);

    socket.on("room-users-response", (response) => {
      console.log("ROOM USERS:", response);
      setRoomUser(response);
    });
    // Handle incoming messages
    socket.on("messageResponse", (data) => {
      setMessages((prev) => [...prev, data]);
    });

    // Handle disconnection
    socket.on("disconnect", () => {
      console.log("Disconnected from server");
    });

    // Handle errors
    socket.on("connect_error", (err) => {
      console.error("Connection Error:", err.message);
    });

    // Cleanup on unmount
    return () => {
      socket.disconnect();
      socket.removeAllListeners();
      socketRef.current = null;
      setSocketInstance(null);
    };
  }, [streamKey]);

  useEffect(() => {
    // 👇️ scroll to bottom every time messages change
    lastMessageRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className={"rtmp-chat"}>
      <div className="chat-main">
        <ChatBody messages={messages} socket={socketInstance} lastMessageRef={lastMessageRef} roomUser={roomUser} chatPreference={chatPreference} />
      </div>
    </div>
  );
};

export default ChatRTMP;
